import ShoppingBagViewController from './ShoppingBagViewController';

export default ShoppingBagViewController;
